import { useCallback } from 'react';
import { useOpenModal } from 'src/common/components/next-modal';
import { PROXY_TARGET } from 'src/env';
import { useGetPageId } from 'src/utils/getPageId';

export const useOpenDownloadDesktopDialog = () => {
  const openModal = useOpenModal();
  const pageId = useGetPageId();
  return useCallback(
    (lowVersion: boolean) => {
      openModal.warning({
        title: lowVersion ? '当前客户端版本过小' : '达文件数量/大小处理上限',
        content: lowVersion ? '请到官网下载最新版本' : '请下载/打开客户端',
        cancelText: '取消',
        confirmText: lowVersion ? '去下载' : '下载/打开客户端',
        colorType: 'active',
        confirm: () => {
          if (!lowVersion) {
            // 尝试打开客户端
            window.location.href = `flowus://flowus.cn/${pageId}`;
          }
          setTimeout(() => {
            window.location.href = `${PROXY_TARGET}/download`;
          }, 3000);
        },
      });
    },
    [openModal, pageId]
  );
};
